module.exports = __webpack_public_path__ + "static/Custom-UI-Rendering-6e06c25d4fda49cb290899452e9b7611.png";